import { InjectionToken } from '@angular/core';
import { environment, IInfrastructureConfig } from '@resident-nx/shared';

export const INFRASTRUCTURE_CONFIG = new InjectionToken<IInfrastructureConfig>(
  'INFRASTRUCTURE_CONFIG'
);
export const infrastructureConfig: IInfrastructureConfig = {
  environment,
};
